import { render, staticRenderFns } from "./orderWaitRefund.vue?vue&type=template&id=6fc3e77e&scoped=true"
import script from "./orderWaitRefund.vue?vue&type=script&lang=js"
export * from "./orderWaitRefund.vue?vue&type=script&lang=js"
import style0 from "./orderWaitRefund.vue?vue&type=style&index=0&id=6fc3e77e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc3e77e",
  null
  
)

export default component.exports